var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check",class:{'done' : _vm.formatDone}},[_c('i',{staticClass:"mdi mdi-check-box-outline mdi-18px"}),_c('p',[_vm._v(" "+_vm._s(_vm.done)+"/"+_vm._s(_vm.total)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }